import React, { useState } from 'react'
import { accordionData } from '../data'

export default function AccordionTwo() {
    let [activeTab, setActiveTab] = useState(1)
  return (
        <div className="accordion mt-4 pt-2">
           {accordionData.map((item,index)=>{
                return(
                        <div className="accordion-item rounded mt-2 border" key={index}>
                            <h2 className="accordion-header">
                                <button className={`accordion-button border-0 bg-light ${activeTab === item.id ? '' : 'collapsed'}`} type="button" onClick={()=>setActiveTab(item.id)}>

                                    {item.title}
                                </button>
                            </h2>
                            <div className={`accordion-collapse border-0 collapse ${activeTab === item.id ? 'show' : ''}`}>
                                <div className="accordion-body text-muted">
                                    {item.desc}
                                </div>
                            </div>
                        </div>
                )
            })}
        </div>
  )
}
